export default __webpack_public_path__ + "static/16.Orangetree-cd76874f5ec0dc2fe73355df1d215394.png";